import * as React from 'react';



export default class Ascending extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd">
            <path fill="#43ADF1" d="M13.854 6.799l-.398-1.04h-2.565l-.398 1.04h-1.04l2.128-5.415h1.185l2.127 5.415h-1.039zm-1.68-4.611l-1.015 2.735h2.03l-1.016-2.735z"/>
            <path fill="#000" d="M10.144 14.917v-.771l2.768-3.808h-2.768v-.836h4.002v.771l-2.768 3.808h2.825v.836z"/>
            <g stroke="#000" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5.055 1.552v11.91M1.762 11.18l3.29 2.92 3.289-2.92"/>
            </g>
        </g>
      </svg>
    )
  }
}
